import { useQuery } from '@tanstack/react-query';

import { notificationRepository } from '../../infrastructure/repositories';
import type { GetNotificationsRequest } from '../../domain/types';

export const notificationKeys = {
  all: ['notification'] as const,
  lists: () => [...notificationKeys.all, 'list'] as const,
  list: (request: GetNotificationsRequest) => [...notificationKeys.lists(), request] as const,
  unreadCount: () => [...notificationKeys.all, 'unread-count'] as const,
};

export function useNotificationList(request: GetNotificationsRequest) {
  return useQuery({ queryKey: notificationKeys.list(request), queryFn: () => notificationRepository.getNotifications(request), staleTime: 30 * 1000 });
}
